<pxc-image-overlay [caption]="$safeNavigationMigration(file?.name)" [showDelete]="showDelete" (delete)="delete.emit()">
  @if (src$ | async; as src) {
    @switch (fileType) {
      @case (MediaType.IMAGE) {
        @if ((error$ | async) === null) {
          <img
            class="h-full w-full object-cover"
            data-testid="image"
            [alt]="MediaType.IMAGE"
            [src]="src"
            (error)="error$.next($event)" />
        } @else {
          <pxc-image-broken data-testid="error" />
        }
      }
      @case (MediaType.VIDEO) {
        <pxc-video-info
          class="absolute bottom-0 left-0 right-0 bg-linear-to-b from-transparent via-background-primary-solid/40 via-60% to-background-primary-solid/60 text-text-white"
          [duration]="duration$ | async" />
        @if ((error$ | async) === null) {
          <video
            class="h-full w-full object-cover"
            data-testid="video"
            [src]="src"
            (error)="error$.next($event)"
            (loadedmetadata)="duration$.next($event.target.duration)"></video>
        } @else {
          <pxc-image-broken data-testid="error" icon="@tui.video-off" />
        }
      }
      @default {
        <pxc-image-broken data-testid="error" />
      }
    }
  } @else {
    <pxc-image-loading class="h-full w-full" data-testid="loading" />
  }
  <ng-content />
</pxc-image-overlay>
